export default function deviceSlice(state) {
  return state.device;
}

export const platformSelector = (state) => state.device?.platform ?? 'web';
